import styled from 'styled-components';

import {
  Input as SemanticInput,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: 300px;
  margin-left: 10px;
`;

export const InputRemovedReason = styled(SemanticInput)`
// needs a width only wide enough to fit the placeholder text
  width: 100%;
`;

export const TextLabel = styled(TextLayoutComponent)``;
